export const TEST_ID = 'detailsIcon';
